module.exports = __webpack_public_path__ + "static/img/close.0193d72a.svg";